const [ w, d ] = [ window, document ]
const referrer = d.referrer ? new URL( d.referrer ) : ''
let article

const init = () => {
  const referrerID = parseInt( referrer.searchParams.get('article') )
  article = $.getArticles({ content: 'shop', post_id: referrerID })
}

const documentLoaded = async () => {
  article = await article
  article = article.shift()
  const target = d.querySelector('.formitem__body textarea[name="area_0"]')
  target.value =
`======================================
商品名： ${article.title}
${article.desc}
URL： ${d.referrer}
======================================`

  //オプション内容をフォームに投入
  if( window.query_string('itemoption') ) {
    const optionTarget = d.querySelector('.formitem__body textarea[name="area_1"]')
    const optionName = window.query_string('itemoption').replace(/\+/g," ")
    const optionNameEnc = decodeURIComponent(optionName)

    optionTarget.value = optionNameEnc.replaceAll(',', "\n")
  }
}

export default function PURCHASE () {
  if( referrer && referrer.pathname.toLowerCase() == '/shop/' && referrer.searchParams.get('mode') == 'detail' ){
    init()
    $( documentLoaded )
  }
}